import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Pages/Home';

import ServicePage from './components/Pages/ServicePage';
import AboutPage from './components/Pages/AboutPage';

import ContactPage from './components/Pages/ContactPage';
import Layout2 from './components/Layout/Layout2';
import TechStartupPage from './components/Pages/TechStartupPage';

import ErrorPage from './components/Pages/ErrorPage';
import PrivacyPage from './components/Pages/PrivacyPage';
import TermsPage from './components/Pages/TermsPage';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path='/' element={<Layout darkMode />}>
        <Route path='about' element={<AboutPage darkMode />} />
        <Route path='privacy' element={<PrivacyPage />} />
        <Route path='terms' element={<TermsPage darkMode />} />
        <Route path='service' element={<ServicePage />} />

        <Route path='contact' element={<ContactPage />} />
      </Route>
      <Route path='/' element={<Layout2 darkMode />}>
        <Route index element={<Home />} />
        <Route path='tech-startup' element={<TechStartupPage />} />
      </Route>

      <Route path='*' element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
